import { FC } from "react";
import { Box, Skeleton } from "@mui/material";
import { styled } from "@mui/material/styles";

const BoxStyled = styled(Box)(() => ({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
}));

const SkeletonImage = styled(Skeleton)(({ theme }) => ({
    marginBottom: theme.spacing(2),
}));

const SkeletonTitle = styled(Skeleton)(({ theme }) => ({
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
}));

const SkeletonDescription = styled(Skeleton)(({ theme }) => ({
    marginBottom: theme.spacing(1),
}));

const TenantInfoPopoverSkeleton: FC = () => {
    return (
        <BoxStyled>
            <SkeletonImage variant="rectangular" width={210} height={90} />
            <SkeletonTitle width={100} />
            <Skeleton width={200} />
            <Skeleton width={210} />
            <SkeletonDescription width={120} />
            <SkeletonTitle width={150} />
            <SkeletonDescription width={120} />
            <SkeletonDescription width={100} />
            <SkeletonDescription width={90} />
        </BoxStyled>
    );
};

export default TenantInfoPopoverSkeleton;
